import React, { FunctionComponent, useState, ChangeEvent } from "react";
import { connect } from "react-redux";
import createSession, {
  CreateSession,
} from "../../../redux/actions/sessions/createSession";
import { Card, Row, Col, Button, Input, Space } from "antd";
import "./index.scss";
import Form from "antd/lib/form/Form";

type LoginProps = { authenticate: CreateSession };
export const Login: FunctionComponent<LoginProps> = ({ authenticate }: LoginProps) => {
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const emailChange = (val: ChangeEvent<HTMLInputElement>) => {
    setEmail(val.target.value);
  };

  const passwordChange = (val: ChangeEvent<HTMLInputElement>) => {
    setPassword(val.target.value);
  };

  const onFinish = () => {
    authenticate({ email, password })
  };

  return (
    <Row justify="space-around" align="middle" className="login">
      <Col xs={24} sm={20} md={10} xl={8}>
        <Card title="OwnLocal Report Tool">
          <Form onFinish={onFinish}>
            <Space direction="vertical" size="middle">
              <Input placeholder="Email" value={email} onChange={emailChange} />
              <Input.Password
                placeholder="Password"
                value={password}
                onChange={passwordChange}
              />
              <Button type="primary" block htmlType="submit">
                Login
              </Button>
            </Space>
          </Form>
        </Card>
      </Col>
    </Row>
  );
};

const mapDispatchToProps = {
  authenticate: createSession,
};

export default connect(null, mapDispatchToProps)(Login);
